var _desc, _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTarget(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "target [#82]") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Dribbble-Light-Preview",
    transform: "translate(-300.000000, -7839.000000)",
    fill: "#000000"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icons",
    transform: "translate(56.000000, 160.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M255,7689 C255,7689.552 254.552,7690 254,7690 C253.448,7690 253,7689.552 253,7689 C253,7688.448 253.448,7688 254,7688 C254.552,7688 255,7688.448 255,7689 M259,7690 L259.91,7690 C259.486,7692.507 257.507,7694.486 255,7694.91 L255,7694 C255,7693.448 254.552,7693 254,7693 C253.448,7693 253,7693.448 253,7694 L253,7694.91 C250.493,7694.486 248.514,7692.507 248.09,7690 L249,7690 C249.552,7690 250,7689.552 250,7689 C250,7688.448 249.552,7688 249,7688 L248.09,7688 C248.514,7685.493 250.493,7683.514 253,7683.09 L253,7684 C253,7684.552 253.448,7685 254,7685 C254.552,7685 255,7684.552 255,7684 L255,7683.09 C257.507,7683.514 259.486,7685.493 259.91,7688 L259,7688 C258.448,7688 258,7688.448 258,7689 C258,7689.552 258.448,7690 259,7690 M263,7688 L261.931,7688 C261.479,7684.383 258.617,7681.521 255,7681.069 L255,7680 C255,7679.448 254.552,7679 254,7679 C253.448,7679 253,7679.448 253,7680 L253,7681.069 C249.383,7681.521 246.521,7684.383 246.069,7688 L245,7688 C244.448,7688 244,7688.448 244,7689 C244,7689.552 244.448,7690 245,7690 L246.069,7690 C246.521,7693.617 249.383,7696.479 253,7696.931 L253,7698 C253,7698.552 253.448,7699 254,7699 C254.552,7699 255,7698.552 255,7698 L255,7696.931 C258.617,7696.479 261.479,7693.617 261.931,7690 L263,7690 C263.552,7690 264,7689.552 264,7689 C264,7688.448 263.552,7688 263,7688",
    id: "target-[#82]"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTarget);
export default __webpack_public_path__ + "static/media/target.8a001a460c8b39a4c1d5cd214fc81d8d.svg";
export { ForwardRef as ReactComponent };